import type { ReactNode } from 'react'
import React, { useMemo, createContext, useContext, useEffect, useRef } from 'react'
import { usePersonPageParams } from '../person-page/personPageRouteUtil'
import { useNotes } from '../data-service/useNotes'
import type { Note } from '../data-service/notes'

type value = {
  notes: Note[]
  loading: boolean
}

const PersonNotesContext = createContext<value>({ notes: [], loading: true })

export const usePersonNotes = (): value => useContext(PersonNotesContext)

export default function PersonNotesProvider({ children }: { children: ReactNode }): JSX.Element {
  const { pid, subPage } = usePersonPageParams('full')
  const isFirstRender = useRef(true)
  let numberOfNoteDisplayed = 0
  if (subPage === 'details')
    numberOfNoteDisplayed = 3 // for MiniNotes
  else if (subPage === 'family' || subPage === 'non-vitals' || subPage === 'vitals')
    numberOfNoteDisplayed = 1 // for AlertNoteBanner
  else if (subPage === 'collaborate') numberOfNoteDisplayed = Infinity

  const { notes, isLoading, mutate } = useNotes('person', pid, numberOfNoteDisplayed)

  const value = useMemo(() => ({ notes: notes ?? [], loading: isLoading }), [isLoading, notes])

  useEffect(() => {
    if (subPage === 'details' || subPage === 'collaborate') {
      !isFirstRender.current && mutate()
    }
    isFirstRender.current = false
  }, [mutate, subPage])

  return <PersonNotesContext.Provider value={value}>{children}</PersonNotesContext.Provider>
}
